export default __webpack_public_path__ + "static/media/pastry.581d2ffc.png";